import {
    CATEGORY_PRIMARY_SENTINEL,
    CATEGORY_SECONDARY_SENTINEL,
    DEFAULT_CATEGORY_BORDER_COLOR,
    DEFAULT_CATEGORY_SECONDARY_COLOR,
} from "@constants/index";

// Narrowing typé unique pour generalDesign : `template.content.generalDesign`
// est accédé dynamiquement (pas de champ fortement typé) et était jusqu'ici
// forcé par `as GeneralDesignType` dans chaque consommateur — ce qui désactive
// la vérification du compilateur. Ce type guard remplace les casts : il vérifie
// que `colors` est bien un tableau AVANT de traiter l'objet comme un
// GeneralDesignType, rendant l'accès colors[0]/[1] sûr sans optional chaining
// incohérent avec le type global (où `colors` est non-optionnel).
export function isGeneralDesign(value: unknown): value is GeneralDesignType {
    return (
        typeof value === "object" &&
        value !== null &&
        Array.isArray((value as { colors?: unknown }).colors)
    );
}

// Règle métier unique de résolution des sentinelles de couleur catégorie
// (ESS-3850), partagée entre le panneau de réglage et la preview pour éviter
// que l'aperçu diverge du rendu réel (DRY). `color` peut être :
//   - CATEGORY_PRIMARY_SENTINEL   -> generalDesign.colors[0] (fallback marque)
//   - CATEGORY_SECONDARY_SENTINEL -> generalDesign.colors[1] (fallback blanc)
//   - n'importe quel hex littéral -> renvoyé inchangé
// `generalDesign` est `unknown` : on le narrowe via isGeneralDesign plutôt que
// par un cast, donc une forme réelle qui changerait (renommage de `colors`,
// contenu non-tableau) retombe sur les fallbacks au lieu de crasher.
export function resolveCategoryColor(
    generalDesign: unknown,
    color: string
): string {
    if (color === CATEGORY_PRIMARY_SENTINEL) {
        return isGeneralDesign(generalDesign)
            ? generalDesign.colors[0]?.content ?? DEFAULT_CATEGORY_BORDER_COLOR
            : DEFAULT_CATEGORY_BORDER_COLOR;
    }
    if (color === CATEGORY_SECONDARY_SENTINEL) {
        return isGeneralDesign(generalDesign)
            ? generalDesign.colors[1]?.content ??
                  DEFAULT_CATEGORY_SECONDARY_COLOR
            : DEFAULT_CATEGORY_SECONDARY_COLOR;
    }
    return color;
}
